<template>
  <div class="chart-container">
    <canvas id="licenses-chart"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js';

export default {
  name: 'HorizontalBarChart',
  data() {
    return {
      chartInstance: null,
    };
  },
  props: {

    licenses: {
      type: Object,
      required: true
    },

  },
  mounted() {
    const ctx=document.getElementById('licenses-chart').getContext('2d');



    this.chartInstance=new Chart(ctx, {
      type: 'bar',
      data: {
        labels: Object.values(this.licenses.backup).map(
          (value) => { return value.nome_licenza }),
        datasets: [
          {
            label: this.$t('Used Slots'),
            data: Object.values(this.licenses.backup).map(
              (value) => { return value.used_slots }
            ),
            backgroundColor: '#253789',
            borderColor: '#253789',
            borderWidth: 0
          },
          {
            label: this.$t('Total Slots'),
            data: Object.values(this.licenses.backup).map(
              (value) => { return value.total_slots }
            ),
            backgroundColor: 'rgba(54, 54, 54, 0.2)',
            borderColor: 'rgba(54, 54, 54, 1)',
            borderWidth: 0
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: false,
        },
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            stacked: true
          }],
          yAxes: [{
            stacked: true
          }]
        },
        tooltips: {
          enabled: true
        },
        animation: {
          /* onComplete: function () {
            const chartInstance = this.chart;
            const ctx = chartInstance.ctx;
            ctx.font = Chart.helpers.fontString(12, 'normal', 'Poppins');
            ctx.fillStyle = '#000';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'bottom';

            this.data.datasets.forEach(function (dataset, i) {
              const meta = chartInstance.controller.getDatasetMeta(i);
              meta.data.forEach(function (bar, index) {
                const data = dataset.data[index];
                ctx.fillText(data, bar._model.x - 10, bar._model.y + 5);
              });
            });
          } */
        }
      }
    });

    window.addEventListener('resize', this.resize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
  },
  methods: {
    resize() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    }
  }
};
</script>

<style scoped>
.chart-container {
  position: relative;
  width: 100%;
  height: 250px;
}

canvas {
  width: 100% !important;
  height: 100% !important;
}
</style>
